var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo, useState } from 'react';
import Context from './Context';
import safelyStringifyJSON from '../../../utils/safelyStringifyJSON';
import { useConfiguration } from './utils';
var ConfigurationProvider = function (_a) {
    var children = _a.children, appNameConfig = _a.appNameConfig;
    var config = useConfiguration(appNameConfig === null || appNameConfig === void 0 ? void 0 : appNameConfig.variant);
    var _b = useState(config.immediatelyLoadImages), is360Mode = _b[0], setIs360Mode = _b[1];
    var activate360Mode = function () { return setIs360Mode(true); };
    var deactivate360Mode = function () { return setIs360Mode(false); };
    var contextValue = useMemo(function () { return (__assign(__assign(__assign({}, appNameConfig), config), { is360Mode: is360Mode, activate360Mode: activate360Mode, deactivate360Mode: deactivate360Mode })); }, [safelyStringifyJSON(config), safelyStringifyJSON(appNameConfig), is360Mode]);
    return React.createElement(Context.Provider, { value: contextValue }, children);
};
export default ConfigurationProvider;
